import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map } from 'rxjs/operators';
import { ArticleAccessoriesModalComponent } from '../../catalog-components/article-accessories-modal/article-accessories-modal.component';
import { WeylandSteelArticle } from '../../../../interfaces/steel-article.model';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ArticleAccessoriesDialogService {
  private dialogRef: MatDialogRef<ArticleAccessoriesModalComponent> | undefined;

  constructor(private dialog: MatDialog) {}

  public open(article: WeylandSteelArticle): void {
    this.dialogRef = this.dialog.open(ArticleAccessoriesModalComponent, {
      data: article,
      height: '80%',
      width: '80%',
      maxWidth: '1260px',
    });

    this.dialogRef
      .afterClosed()
      .pipe(
        filter((data?: any) => !!data?.article),
        map((data: { article: WeylandSteelArticle }) => data.article),
        untilDestroyed(this),
      )
      .subscribe((article: WeylandSteelArticle) => this.open(article));
  }
}
